import React, { useState } from 'react';

const Gallery = ({ title, description, items, featured = false }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const openLightbox = (item) => {
    setSelectedItem(item);
  };

  const closeLightbox = () => {
    setSelectedItem(null);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeLightbox();
    }
  };

  return (
    <section className={`gallery-section ${featured ? 'gallery-featured' : ''}`}>
      <h2>{title}</h2>
      {description && <p className="gallery-description">{description}</p>}
      
      <div className={`gallery-grid ${featured ? 'gallery-grid-featured' : ''}`}>
        {items.map((item, index) => (
          <div 
            key={index} 
            className={`gallery-item ${featured && index === 0 ? 'gallery-item-hero' : ''}`}
            onClick={() => openLightbox(item)}
          >
            {item.type === 'video' ? (
              <div className="gallery-video-thumb">
                <video src={item.src} muted preload="metadata" />
                <div className="play-overlay">
                  <span className="play-icon">▶</span>
                </div>
              </div>
            ) : (
              <img src={item.src} alt={item.caption} loading="lazy" />
            )}
            {item.caption && (
              <div className="gallery-caption">
                <span>{item.caption}</span>
              </div>
            )}
          </div>
        ))}
      </div>

      {selectedItem && (
        <div 
          className="lightbox" 
          onClick={closeLightbox}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>×</button>
            {selectedItem.type === 'video' ? (
              <video 
                src={selectedItem.src} 
                controls 
                autoPlay 
                playsInline
                className="lightbox-media"
              />
            ) : (
              <img 
                src={selectedItem.src} 
                alt={selectedItem.caption} 
                className="lightbox-media"
              />
            )}
            {selectedItem.caption && (
              <p className="lightbox-caption">{selectedItem.caption}</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
